import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { createCaptureExtractionEquipment, deleteCaptureExtractionEquipment, getCaptureExtractionEquipments, updateCaptureExtractionEquipment } from "../../api/captures/extractionEquipment";
import { ExtractionEquipmentForm } from "../../types/forms/capture";

export const useCaptureExtractionEquipment = (captureIdStr?: string) => {
  const queryClient = useQueryClient();
  const captureId = Number(captureIdStr);

  const queryKey = ["capture", captureId, "extraction-equipment"];

  const result = useQuery({
    queryKey,
    queryFn: () => getCaptureExtractionEquipments(captureId),
    enabled: !!captureId,
  });

  const createMutation = useMutation({
    mutationFn: (values: ExtractionEquipmentForm) => createCaptureExtractionEquipment(captureId, values),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey });
    },
  });

  const updateMutation = useMutation({
    mutationFn: ({ equipmentId, values }: { equipmentId: number; values: ExtractionEquipmentForm }) => updateCaptureExtractionEquipment(captureId, equipmentId, values),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey });
    },
  });

  const deleteMutation = useMutation({
    mutationFn: (equipmentId: number) => deleteCaptureExtractionEquipment(captureId, equipmentId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey });
    },
  });

  return {
    extractionEquipmentsData: result.data ?? [],
    isPending: result.isPending,
    isError: result.isError,
    error: result.error,
    createExtractionEquipment: createMutation.mutateAsync,
    updateExtractionEquipment: updateMutation.mutateAsync,
    deleteExtractionEquipment: deleteMutation.mutateAsync,
    isUpdating: createMutation.isPending || updateMutation.isPending || deleteMutation.isPending,
  };
};
